const SET_SELECTED_SALES_GROUP = 'app/sales-rep/SET_SELECTED_SALES_GROUP';

const setSelectedSalesGroup = (salesGroup) => ({
  type: SET_SELECTED_SALES_GROUP,
  salesGroup,
});

export { SET_SELECTED_SALES_GROUP, setSelectedSalesGroup };
